import { Scale, Unplug } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { connectScale, disconnectScale, useScale } from "@/lib/scale";

export default function ScaleButton({ className = "" }) {
  const { t } = useApp();
  const s = useScale();
  const on = s.status === "connected";
  return (
    <button type="button" onClick={on ? disconnectScale : connectScale} data-testid="scale-connect-btn" data-status={s.status}
      title={on ? t("scale_disconnect") : t("scale_connect")}
      className={`h-14 px-4 rounded-2xl flex items-center gap-2 font-bold border transition-colors ${on ? "bg-[#E3F6EC] border-[#1F9D55]/40 text-[#1F9D55]" : "bg-white border-border text-[#0B2A5B] hover:border-primary"} ${className}`}>
      {on ? <Scale className="w-6 h-6" /> : <Unplug className="w-6 h-6" />}
      <span className="hidden sm:inline" dir="ltr" data-testid="scale-btn-reading">{on ? `${(s.kg - s.tare).toFixed(3)} kg` : t("scale")}</span>
    </button>
  );
}
